import mapboxgl from 'mapbox-gl';
import * as m from "./mapInit";
import * as ch from "./contentHelper";
import * as p from "./popup";
import $ from "jquery";

//--------------------------------------------------------------
//EMISSION
let headline = 'Emission<br/>data';
let addClassName = 'emission';

let mapLayerNames = [
  'nuts3-emission-1',
  'nuts3-emission-2',
  'nuts3-emission-3',
  'nuts3-emission-4'
];

//add layers to toggleAbleLayers in mapInit
mapLayerNames.forEach(function(layerName){m.addToggleableLayer(layerName);});

let properties = [
  ['emission-2017',
  'emissions-variation-2010-2016',
  'carbon-intensity-2016',
  'carbon-intensity-variation-2010-2016'
  ],

  [
  'emissions-variation-2010-2016',
  'emission-2017',
  'carbon-intensity-2016',
  'carbon-intensity-variation-2010-2016'
  ],

  [
  'carbon-intensity-2016',
  'emission-2017',
  'emissions-variation-2010-2016',
  'carbon-intensity-variation-2010-2016'
  ],

  [
  'carbon-intensity-variation-2010-2016',
  'emission-2017',
  'emissions-variation-2010-2016',
  'carbon-intensity-2016'
  ]

];

let valueNames = [
  [
  'Industrial CO2 Emissions reported under the EU Emission Trading Scheme [in T CO2]',
  'Variation of Industrial CO2 Emissions<br/>[2016 compared to 2010 in %]',
  'Carbon Intensity [T CO2/ million GDP], 2016',
  'Variation of Carbon Intensity<br/> [2016 compared to 2010 in %]'
  ],

  [
  'Variation of Industrial CO2 Emissions [2010 compared to 2016 in %]',
  'Industrial CO2 Emissions reported under the EU Emission Trading Scheme [in T CO2]',
  'Carbon Intensity [T CO2/ million GDP], 2016',
  'Variation of Carbon Intensity<br/> [2016 compared to 2010 in %]'
  ],

  [
  'Carbon Intensity [T CO2/ million GDP], 2016',
  'Industrial CO2 Emissions reported under the EU Emission Trading Scheme [in T CO2]',
  'Variation of Industrial CO2 Emissions [2010 compared to 2016 in %]',
  'Variation of Carbon Intensity<br/> [2016 compared to 2010 in %]'
  ],

  [
  'Variation of Carbon Intensity<br/> [2016 compared to 2010 in %]',
  'Industrial CO2 Emissions reported under the EU Emission Trading Scheme [in T CO2]',
  'Variation of Industrial CO2 Emissions [2010 compared to 2016 in %]',
  'Carbon Intensity [T CO2/ million GDP], 2016'
  ]

];

let valueDescriptions = [
  [
  '',
  '',
  '',
  ''
  ],

  [
  '',
  '',
  '',
  ''
  ],

  [
  '',
  '',
  '',
  ''
  ],

  [
  '',
  '',
  '',
  ''
  ]


];
  
let infoBox = [
  [
    [''],
    ['Industrial emissions that have been reported in the EU Emission Trading Scheme'],
    [''],
    ['']
 ],

  [
    [''],
    ['Industrial emissions that have been reported in the EU Emission Trading Scheme'],
    [''],
    ['']
 ],

  [
    [''],
    ['Industrial emissions that have been reported in the EU Emission Trading Scheme'],
    [''],
    ['']
 ],

  [
    [''],
    ['Industrial emissions that have been reported in the EU Emission Trading Scheme'],
    [''],
    ['']
 ]


];

let addTextAfterValue = [
[
  [''],
  ['%'],
  [''],
  ['%']
],

[
  ['%'],
  [''],
  [''],
  ['%']
],

[
  [''],
  [''],
  ['%'],
  ['%']
],

[
  ['%'],
  [''],
  ['%'],
  ['']
],


];

//--------------------------------------------------------------

for(let i = 0; i < properties.length; i++){
  m.map.on('click',mapLayerNames[i], function (e) {
    p.getPopup(
      e,
      addClassName,
      headline,
      properties[i],
      valueNames[i],
      valueDescriptions[i],
      infoBox[i],
      addTextAfterValue[i] );
  });
};